module.exports = __webpack_public_path__ + "static/hif-graphic-760942c9a7e5e409471736d34d50ec24.jpg";